export default {
  "title": "獵魔人",
  "intro": "累計對幽靈進行開炮打擊次數達標即可領取對應獎勵,貢獻越多獎勵越豐富!",
  "login": "登入",
  "logout": "登出",
  "howToPlay": "活動規則詳情",
  "contributeDesc": "累計對幽靈進行開炮打擊次數達標即可領取對應獎勵,貢獻越多獎勵越豐富!",
  "account": "帳號 ID",
  "code": "驗證碼",
  "sendCode": "發送游戲內郵箱驗證碼",
  "codeSent": "驗證碼已發送，請在遊戲信箱內查看",
  "submit": "確認",
  "cancel": "取消",
  "ok": "知道了",
  "rewardConfirm": "確認",
  "available": "剩餘炮彈數量",
  "total": "累計打擊",
  "ghostDefeated": "鬼魂已被擊敗",
  "globalTitle": "鬼魂擊敗進度",
  "strikeTitle": "投入打擊",
  "strike": "開炮！！！",
  "strikeRecord": "開炮",
  "taskTitle": "墳場搏擊",
  "missionClaimed": "已領取",
  "missionCompleted": "可領取",
  "missionIncomplete": "未達成",
  "share": "分享",
  "sharing": "分享中",
  "shareOk": "分享完成",
  "milestoneTitle": "個人里程碑",
  "times": "次",
  "recordTitle": "獲獎記錄",
  "recordDialogTitle": "獲獎記錄",
  "recordReward": "獎勵",
  "recordTime": "領取時間",
  "refresh": "重新整理",
  "empty": "暫無數據",
  "receive": "可領取",
  "received": "已領取",
  "notReady": "未達成",
  "locked": "未解鎖",
  "unlocked": "可領取",
  "rewardTitle": "獲得獎勵",
  "phase": {
    "not_start": "活動尚未開始",
    "play": "活動進行中",
    "view_only": "活動已結束",
    "closed": "頁面已關閉"
  },
  "actTime": {
    "notStart": "活動尚未開始",
    "ended": "活動已結束",
    "startCountdown": "距離開始還有",
    "day": "天"
  },
  "taskCycle": {
    "daily": "每日任務",
    "weekly": "每週任務"
  },
  "tasks": {
    "hw_daily_login": "每日登錄",
    "hw_daily_play_any_1": "完成 1 次任意模式",
    "hw_daily_play_any_3": "完成 3 次任意模式",
    "hw_daily_mojin_3": "完成 3 次迷境奪金",
    "hw_weekly_share": "分享到社交媒體"
  },
  "props": {
    "90301916": "【頭像框】糖衣炮彈",
    "70100101": "金鑽",
    "70100011": "金幣",
    "50108900": "卡諾魯斯（3天）",
    "70100004": "點券",
    "80103001": "排位保護卡",
    "10301029": "鐮刀-絕命天啟（3天）",
    "80102101": "金鑽抽獎券",
    "82101002": "鮮花",
    "80202003": "槍械三階升級卡",
    "82101003": "棒棒糖",
    "81010999": "萬能成長幣",
    "70100013": "秘寶券",
    "70100014": "秘寶鈅匙",
    "10101086": "AK15-蓐收"
  },
  "footer": {
    "privacyPolicy": "隱私權政策",
    "userAgreement": "使用者協定",
    "customerService": "請透過信箱 ministarcustomerservice{'@'}gmail.com 聯絡我們"
  },
  "error": {
    "code401": "登入狀態已過期",
    "code1001": "參數錯誤",
    "code1004": "請稍後再試",
    "code2001": "活動尚未開始",
    "code2002": "活動已結束",
    "code2003": "頁面已關閉",
    "code2201": "任務未完成",
    "code2202": "獎勵已領取",
    "code2203": "任務未配置",
    "code2301": "沒有可用打擊次數",
    "code2401": "節點尚未解锁",
    "code2402": "獎勵已領取",
    "code2403": "節點不存在",
    "code2501": "未達到里程碑條件",
    "code2502": "里程碑已領取",
    "code2503": "里程碑不存在",
    "code2801": "獎勵已領取",
    "code429": "請求過於頻繁"
  },
  "howToPlayBody": "🎃 獵魔人｜合力擊敗大幽靈\n萬聖夜，一隻超大鬼魂闖進迷你槍戰精英的世界，張牙舞爪、攪亂全服！湯姆、諾娜、凌羽和星辰機甲號召全服精英——集結火力，一次次開炮，層層轟碎鬼魂血條，合力擊敗這隻大幽靈，守住萬聖夜！\n\n\n📅 活動時間\n 參與時間：10月23日 – 11月9日（GMT+8）\n 領獎/兌換：活動開始至11月16日（GMT+8）\n ※ 請務必在領獎期內領取，逾期視為放棄。\n\n🔥 怎麼玩？三步擊敗大幽靈\n第一步：獲取炮彈數量\n 進入「墳場搏擊」，完成每日 / 每週任務即可獲得打擊次數！\n\n第二步：開炮！轟擊大幽靈\n 點擊「開炮！！！」對超大鬼魂發起攻擊！你的每一次開炮，都會即時扣減鬼魂的全服血量、累加你的個人打擊次數貢獻。與全服獵人一起，把大幽靈的血條一路轟到底！（未用完的開炮次數可跨日保留，不浪費）\n\n第三步：解鎖獎勵\n 全服獎勵：全服血條每打到 25% / 50% / 75% / 100%，所有參與擊敗幽靈的精英一起解鎖對應階段獎勵！血條清空、大幽靈被全服擊敗，全員共享最終大禮！\n 個人獎勵：你自己累計的打擊貢獻，還能額外解鎖「個人里程碑」，層層領獎，打得越多，拿得越多！\n\n🏆 我的記錄\n 所有打擊與領取過的獎勵，都能在「獲獎記錄」裡查看。",
  "shareTitle": "不給糖就搗蛋哦！！！",
  "shareContent": "萬聖夜降臨，擊敗幽靈共享全服大獎。\n別讓到手的獎勵偷偷溜走。",
  "accountPlaceholder": "請輸入帳號",
  "codePlaceholder": "請輸入驗證碼"
}
